import { Component, Input, OnInit } from "@angular/core";
import { Community } from "../../../../shared";

@Component({
  selector: "community-nav-tabs",
  templateUrl: "./community-nav-tabs.component.html",
  styleUrls: [
    "./community-nav-tabs.component.scss",
    "../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class CommunityNavTabsComponent implements OnInit {
  constructor() {}
  @Input() community: Community;
  ngOnInit() {}
}
